var React = require('react');

function NavBackArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Ellipse_12","data-name":"Ellipse 12","fill":"none","stroke":"#848484","strokeWidth":"2","key":0},[React.createElement("circle",{"cx":"20.5","cy":"20.5","r":"20.5","stroke":"none","key":0}),React.createElement("circle",{"cx":"20.5","cy":"20.5","r":"19.5","fill":"none","key":1})]),React.createElement("path",{"id":"Arrow","d":"M-17340.035-15398.292l9.188,9.187,9.186-9.187","transform":"translate(-15373.586 17351.66) rotate(90)","fill":"none","stroke":"#848484","strokeWidth":"2","key":1})]);
}

NavBackArrowInline.defaultProps = {"id":"Back_Arrow","data-name":"Back Arrow","width":"41","height":"41","viewBox":"0 0 41 41"};

module.exports = NavBackArrowInline;

NavBackArrowInline.default = NavBackArrowInline;
